import { platform } from '@/Models';
import Config from '@/Config';
export const chartColorsPalette = [
    'rgba(27, 170, 100, 1)',
    'rgba(37, 201, 162, 1)',
    'rgba(37, 172, 201, 1)',
    'rgba(37, 73, 201, 1)',
    'rgba(201, 37, 96, 1)',
    'rgba(119, 161, 0, 1)',
    'rgba(201, 106, 37, 1)',
    'rgba(27, 170, 100, .6)',
    'rgba(37, 201, 162, .6)',
    'rgba(37, 172, 201, .6)',
    'rgba(37, 73, 201, .6)',
    'rgba(201, 37, 96, .6)',
    'rgba(119, 161, 0, .6)',
    'rgba(201, 106, 37, .6)',
];

export const colorPalette = {
    primary: '#1BAA64',
    primaryLight: '#25C9A2',
    secondary: '#2549C9',
    secondaryLight: '#008FFB',
    secondaryLighter: '#25ACC9',
    warning: '#FFC750',
    danger: '#C92560',
    gray: '#A5AAC0',
    disabled: '#E0E0EA',
    dark: '#353245',
    light: '#E8E8EF',
};

export const chartFonts = {
    [platform.gamefound]: {
        family: 'Nunito Sans',
        size: '11px',
        weight: {
            regular: 600,
            bold: 700,
        },
    },
    [platform.ideafound]: {
        family: 'Inter',
        size: '11px',
        weight: {
            regular: 600,
            bold: 700,
        },
    },
}[Config.platform || platform.gamefound];

export const chartThemes = {
    light: 'light',
    dark: 'dark',
};

export const chartHeights = {
    donut: 300,
    bar: 320,
};